module.exports = require('./helpers/bundle-url').getBundleURL('2BwZt') + "global-opt-in-default-image-banner.8c1c680b.svg";